import { setValue } from '../../lib/immutable_wrapper'
import {
    SET_FILTERED_AND_SORTED_INVOICES, SET_SELECTED_TYPE,
    SET_SELECTED_STATE, SET_START_DATE, SET_END_DATE,
    SET_MIN_AMOUNT, SET_MAX_AMOUNT, SET_NUMBER_INPUT,
    SET_TOTAL_UNTAXED_AMOUNT, SET_TOTAL_AMOUNT, SET_DISPLAY_AS_LIST
} from "./invoicesConstants";
import { getStates, getTypes } from './invoicesActions';
import { ALL_SELECT_OPTION } from '../../constants';

const initialState = {
    currentInvoice: null,
}

const invoicesInitialState = {
    filteredAndSortedInvoices: [],
    allInvoices: [],
    types: getTypes(),
    states: getStates(),
    selectedState: ALL_SELECT_OPTION,
    selectedType: ALL_SELECT_OPTION,
    startDate: null,
    endDate: null,
    minAmount: '',
    maxAmount: '',
    numberInput: '',
    totalUntaxedAmount: 0,
    totalAmount: 0,
    displayAsList: true,
}

export function invoice(state = initialState, action) {
    switch (action.type) {
        default:
            return state;
    }
}

export function invoices(state = invoicesInitialState, action) {
    switch (action.type) {
        case SET_FILTERED_AND_SORTED_INVOICES:
            return setValue(state, ['filteredAndSortedInvoices'], action.invoices);
        case SET_SELECTED_TYPE:
            return setValue(state, ['selectedType'], action.selectedType);
        case SET_SELECTED_STATE:
            return setValue(state, ['selectedState'], action.selectedState);
        case SET_START_DATE:
            return setValue(state, ['startDate'], action.startDate);
        case SET_END_DATE:
            return setValue(state, ['endDate'], action.endDate);
        case SET_MIN_AMOUNT:
            return setValue(state, ['minAmount'], action.minAmount);
        case SET_MAX_AMOUNT:
            return setValue(state, ['maxAmount'], action.maxAmount);
        case SET_NUMBER_INPUT:
            return setValue(state, ['numberInput'], action.numberInput);
        case SET_TOTAL_UNTAXED_AMOUNT:
            return setValue(state, ["totalUntaxedAmount"], action.totalUntaxedAmount);
        case SET_TOTAL_AMOUNT:
            return setValue(state, ["totalAmount"], action.totalAmount);
        case SET_DISPLAY_AS_LIST:
            return setValue(state, ['displayAsList'], action.displayAsList);
        default:
            return state;
    }
}
